import { auth } from "@envirohub/utils";

/**
 * Returns a stable context key for the current customer session.
 * Used to namespace React Query keys so B2B org switch never serves
 * cached data from a different organization.
 *
 * B2C:  "b2c"
 * B2B:  organizationId (e.g. "org-abc123")
 */
export function customerContextKey(): string {
  const session = auth.getSession();
  if (!session) return "anonymous";
  const { scope, organizationId } = session.activeContext;
  if (scope === "CUSTOMER_B2B" && organizationId) return organizationId;
  return "b2c";
}
